module.exports = __webpack_public_path__ + "img/FR18829.3522b22f.png";